import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { MimeTypesEnum, MimeTypesNames } from 'app/enums/mime-types.enum';
import { FileDto } from 'app/models/file';
import { GetReportFile } from 'app/models/generate-report.model';
import { ReportService } from 'app/services/report.service';
import { ToastService } from 'app/services/toast.service';

@Component({
  selector: 'app-file-list-dialog',
  templateUrl: './file-list-dialog.component.html',
  styleUrls: ['./file-list-dialog.component.scss']
})
export class FileListDialogComponent implements OnInit {

  reportId: number;
  files: FileDto[] = [];
  mimeType: string;

  mimeTypes = MimeTypesEnum;
  mimeTypesNames = MimeTypesNames;

  constructor(
    public dialogRef: MatDialogRef<FileListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {reportId: number, files: FileDto[], mimeType?: string},
    private reportService: ReportService,
    private toast: ToastService,
    private fuseProgressBarService: FuseProgressBarService,
  ) {
    this.reportId = data.reportId;
    this.files = data.files;
    this.mimeType = data.mimeType || '';
  }

  ngOnInit() {
  }

  downloadReportFile (fileId: number): void {
    this.fuseProgressBarService.show();
    const getReport: GetReportFile = {fileId, reportRequestId: this.reportId};
    this.reportService.downloadFileReport(getReport)
    .subscribe(()=>{
      this.fuseProgressBarService.hide();
    },
     err => {
      this.fuseProgressBarService.hide();
       this.toast.error(err);
      });
  }

}
